import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import SurveyResponsesEditContent from "../../../components/Pages/SurveyResponses/Edit";

const { displayName } = config;

export default function SurveyResponsesEdit(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Survey Edit`;
  }, []);

  return (
    <Layout>
      <SurveyResponsesEditContent />
    </Layout>
  );
}
